import $ from "jquery";
import 'jquery-validation';

$(document).ready(function(){
    let form = $('#form')
    const urlParams = new URLSearchParams(window.location.search);
    form.validate({
        rules: {
            "name": {
                required: true,
                maxlength: 255
            },
            "phone": {
                required: true,
                maxlength: 20
            },
            "email": {
                required: true,
                email: true
            },
            "course": {
                required: true,
                number: true,
            },
        },
        messages: {
            "name": {
                required: "Vui lòng nhập họ tên",
                maxlength: "Họ tên không hợp lệ"
            },
            "email": {
                required: "Vui lòng nhập nhập email",
                email: "Email không hợp lệ"
            },
            "phone": {
                required: "Vui lòng nhập nhập số điện thoại",
                maxlength: "Số điện thoại không hợp lệ"
            },
            "course": {
                required: "Vui lòng chọn khóa học",
            },
        },
        submitHandler: function() {
            let url = $('.btn-register').data('url')
            let data = {
                'name': form.find('input[name="name"]').val(),
                'phone': form.find('input[name="phone"]').val(),
                'email': form.find('input[name="email"]').val(),
                'course': form.find('select[name="course"]').val(),
                'note': form.find('textarea[name="note"]').val(),
                'source':  urlParams.get('source') 
            };
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                data: data,
                type: "POST",
                url: url,
                success: function(response) {
                    if (response.status == true) {
                        form.find('input').val("");
                        form.find('textarea').val("");
                        form.find('option:selected').remove();
                        form.find('.alert-success').show();
                    }
                },
            });
        }
    });
    $(document).on('click', '.btn-register', function() {
        form.find('.alert-success').hide();
    });
})